import { render, staticRenderFns } from "./AdminTopic.vue?vue&type=template&id=834c1c48"
import script from "./AdminTopic.vue?vue&type=script&lang=js"
export * from "./AdminTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports